<script>
    export let fill = "#fff";
    export let size = 20;
</script>

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   x="0px"
   y="0px"
   viewBox="0 0 79.544998 31.106001"
   enable-background="new 0 0 90 90"
   xml:space="preserve"
   id="svg12"
   width="{size}"
   height="auto"
   fill="{fill}">
   <defs id="defs16" />
   <path
     d="m 75.036,14.52 c 0.761,-0.043 1.547,0.437 1.989,1.213 0.614,1.057 0.401,2.328 -0.474,2.833 -0.88,0.511 -2.083,0.063 -2.697,-1 -0.615,-1.063 -0.401,-2.338 0.474,-2.843 0.213,-0.121 0.453,-0.194 0.708,-0.203 z M 34.487,3.021 h 2.078 c 3.641,0 6.313,1.072 9.146,2.593 1.625,0.875 3.286,1.896 5.093,2.901 1.162,0.641 1.656,2.124 -0.677,2.124 h -15.64 c -0.708,0 -1.28,-0.572 -1.28,-1.28 V 4.302 c 0,-0.715 0.572,-1.281 1.28,-1.281 z m -8.103,0 h 2.525 c 0.708,0 1.281,0.566 1.281,1.281 v 5.057 c 0,0.708 -0.573,1.28 -1.281,1.28 h -12.17 c -2.463,0 -3.063,-2.577 -0.26,-4.061 L 21.806,3.754 C 23.197,3.156 24.759,3.021 26.384,3.021 Z M 27.258,0 C 19.743,0 14.645,4.639 9.255,6.229 L 2.683,8.161 C 0.527,8.797 0,9.744 0,11.463 v 9.202 c 0,2.552 1.178,4.036 3.974,4.036 h 5.458 c 0,-4.598 3.729,-8.328 8.327,-8.328 2.208,0 4.323,0.88 5.886,2.438 1.562,1.563 2.442,3.683 2.442,5.89 H 53.35 c 0,-4.598 3.729,-8.328 8.327,-8.328 2.203,0 4.323,0.88 5.885,2.438 1.563,1.563 2.442,3.683 2.442,5.89 h 6.104 c 1.905,0 3.437,-1.801 3.437,-4.03 v -2.528 c 0,-3.572 -1.875,-5.233 -4.333,-5.833 L 56.219,7.676 C 49.673,5.327 45.096,0 36.565,0 Z"
     id="path2" /><path
     d="m 17.759,31.106 c -3.536,0 -6.405,-2.87 -6.405,-6.406 0,-3.536 2.869,-6.405 6.405,-6.405 1.698,0 3.328,0.676 4.526,1.875 1.203,1.202 1.88,2.833 1.88,4.53 0.001,3.537 -2.869,6.406 -6.406,6.406 z m 0,-4.005 c 1.323,0 2.401,-1.078 2.401,-2.401 0,-1.328 -1.078,-2.4 -2.401,-2.4 -1.327,0 -2.405,1.072 -2.405,2.4 0,1.324 1.078,2.401 2.405,2.401 z"
     id="path4" /><path
     d="m 61.677,31.106 c -3.541,0 -6.405,-2.87 -6.405,-6.406 0,-3.536 2.864,-6.405 6.405,-6.405 1.698,0 3.323,0.676 4.526,1.875 1.202,1.202 1.88,2.833 1.88,4.53 0.001,3.537 -2.874,6.406 -6.406,6.406 z m 0,-4.005 c 1.323,0 2.401,-1.078 2.401,-2.401 0,-1.328 -1.078,-2.4 -2.401,-2.4 -1.328,0 -2.405,1.072 -2.405,2.4 0,1.324 1.077,2.401 2.405,2.401 z"
     id="path6" />
</svg>
